import { useTranslation } from 'react-i18next';

import withRerenderPrevent from '../../common/with-rerender-prevent';

import useScreenTitle from '../../common/use-screen-title';
import useContentFeed from '../../common/use-content-feed';

import Page, {
  PageMain,
  PageSidebar,
  PageTitle,
} from '../../components/ui/page';
import Feed from '../../components/feed';

import './filtered-feed.scss';
import { FilteredFeedNav } from '../../components/filtered-feed-nav/filtered-feed-nav';

const FilteredFeed = ({
  match: {
    params: { filter = 'latest' },
  },
}) => {
  const { t } = useTranslation();

  const capitalizeWord = (w) => w.charAt(0).toUpperCase() + w.slice(1);

  const filterTitle = filter.split('_').map(capitalizeWord).join(' ');

  const filterTranslations = {
    featured: 'content.featured',
    latest: 'landing.latest',
    trending: 'landing.trending',
    community: 'landing.from_the_community',
    bookmarks: 'screens.bookmarks.title',
    resources: 'menu.resources',
    for_you: 'landing.for_you',
    recent_activity: 'screens.recent_activity.title',
  };

  const sectionTitle = t(filterTranslations[filter], filterTitle);

  useScreenTitle(sectionTitle);

  const analyticsData = {
    feed_filter: filter,
    location: 'filtered_feed',
  };

  const { fetching, feedItems, page, canLoadMore, fetchFeed } = useContentFeed({
    filter: filter === 'community' ? 'community_images' : filter,
  });

  return (
    <Page className="filtered-feed">
      <PageSidebar>
        <PageTitle>{sectionTitle}</PageTitle>

        <FilteredFeedNav />
      </PageSidebar>

      <PageMain>
        <Feed
          items={feedItems}
          page={page}
          fetching={fetching}
          canLoadMore={canLoadMore}
          fetchFeed={fetchFeed}
          analyticsData={analyticsData}
          titleHeadingLevel={2}
        />
      </PageMain>
    </Page>
  );
};
export default withRerenderPrevent(FilteredFeed);
